var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBreakerActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "23px",
    viewBox: "0 0 31 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBreakerActive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quick-reply",
    transform: "translate(-9.000000, -375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBreakerActive",
    transform: "translate(9.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quick-msg---selected"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,11 C7.43361966,13.5563751 9.038818,14.8133827 11.6320963,16.0604821 L11.6320963,20.67619 C11.6320963,20.7947562 11.7028104,20.904827 11.8163623,20.9612167 C11.868279,20.9871953 11.9255664,21 11.9824702,21 C12.0496039,21 12.1168654,20.9819011 12.175048,20.946319 L17.7844828,17.5150414 C18.0114586,17.5259992 18.2238568,17.5370801 18.4402191,17.5370801 C25.0307008,17.5370801 30,13.7674642 30,8.76884787 C30,3.76961592 25.0307008,0 18.4402191,0 C15.14517,0 12.2553526,0.942373199 10.1891697,2.50971195 L15.203864,2.50971195 L10.5,11 L7,11 Z",
    id: "Stroke-3",
    stroke: "#FFFFFF",
    fill: "#7EC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,5 L12,5",
    id: "Stroke-5",
    stroke: "#7EC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7 L9,7",
    id: "Stroke-7",
    stroke: "#7EC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,9 L8,9",
    id: "Stroke-9",
    stroke: "#7EC34D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    cx: 16,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    cx: 20,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    cx: 24,
    cy: 9,
    r: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBreakerActive);
export default __webpack_public_path__ + "static/media/icBreakerActive.3fa093a568daa409a4595d0d2d72e260.svg";
export { ForwardRef as ReactComponent };